import React from 'react';
import { AnalyticsTimePeriod, IAnalyticsContext } from 'types/analytics';
import { IProps } from 'types/common';
import { ITenant } from 'types/tenants';
import AnalyticsContext from './AnalyticsContext';
import { setXDomainAccordingToTimePeriod } from './utils';

const AnalyticsProvider: React.FC<IProps> = ({ children }) => {
	const [tenants, setTenants] = React.useState<ITenant[]>([]);
	const [timePeriod, setTimePeriod] = React.useState<string>(
		AnalyticsTimePeriod.Week
	);
	const [xDomain, setXDomain] = React.useState<number[]>(
		setXDomainAccordingToTimePeriod(timePeriod as AnalyticsTimePeriod)
	);

	const context = React.useMemo<IAnalyticsContext>(
		() => ({
			tenants,
			setTenants,
			timePeriod: timePeriod as AnalyticsTimePeriod,
			setTimePeriod,
			xDomain,
			setXDomain
		}),
		[tenants, timePeriod, xDomain]
	);

	return (
		<AnalyticsContext.Provider value={context}>
			{children}
		</AnalyticsContext.Provider>
	);
};

export default AnalyticsProvider;
